/**
 * Live visitor counter — the "N kijken nu" indicator in the nav.
 *
 * Polls the public /api/live endpoint and shows the concurrent-visitor count
 * next to the feed "Live" status. Best-effort and self-hiding: any fetch
 * failure, a null count (analytics unconfigured), or a count of 0 leaves the
 * widget hidden, so it never shows a broken or empty state.
 */

// Between the watch's 60s poll and the 30s server cache: often a cache hit,
// never more than ~2 polls per cache window.
const POLL_INTERVAL_MS = 45000;

export function initLiveViewers() {
    const el = document.getElementById('live-viewers');
    const countEl = document.getElementById('live-viewers-count');
    if (!el || !countEl) return;

    const hide = () => { el.hidden = true; };

    async function refresh() {
        try {
            const res = await fetch('/api/live', { cache: 'no-store' });
            if (!res.ok) return hide();
            const { realtime } = await res.json();
            if (typeof realtime !== 'number' || realtime <= 0) return hide();
            countEl.textContent = realtime;
            el.setAttribute('aria-label', `${realtime} bezoekers nu online`);
            el.hidden = false;
        } catch {
            hide();
        }
    }

    refresh();
    setInterval(refresh, POLL_INTERVAL_MS);
    // Refresh when the tab regains focus so a returning visitor sees a live number.
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') refresh();
    });
}
